module.exports = __webpack_public_path__ + "static/1136727937-wide.0d9f3d32.jpg";